import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
// import { ShapeOptions, CircleProgressComponent, SemiCircleProgressComponent } from 'angular2-progressbar';

import { environment } from '../../../';
import { HttpClientService } from '../../../shared';
import { CookieManagerService, ErrorManagerService } from '../../../shared/';
import { CookieNames, BasicRoutes, CircleUIOptions, ApiEndpoints , OnlineStatus} from '../../constant';
import { PaperPart, PaperReport, NewAttempt } from '../../model';
import { BackButtonService } from './../../../shared/services/back-button.service';

@Component({
  selector: 'app-report-parts',
  templateUrl: '../views/report-parts.component.html',
  styleUrls: ['../../../css/report-parts.component.css', '../../../css/paper-sets.component.css']
})
export class ReportPartsComponent implements OnInit {

  paperSummaryUrl: string = BasicRoutes.clientSummary;
  // @ViewChild(CircleProgressComponent) circleComp: CircleProgressComponent;

  // private circleOptions: ShapeOptions = {
  //   color: CircleUIOptions.fillColor,
  //   trailColor: CircleUIOptions.trailColor,
  //   trailWidth: CircleUIOptions.trailWidth,
  //   duration: CircleUIOptions.duration,
  //   easing: CircleUIOptions.easing,
  //   strokeWidth: CircleUIOptions.strokeWidth,
  //   from: { color: CircleUIOptions.fillColor, a: 0 },
  //   to: { color: CircleUIOptions.baseColor, a: 1 },
  //   step: function (state: any, circle: any) {
  //     circle.path.setAttribute(CircleUIOptions.theme, CircleUIOptions.fillColor);
  //   }
  // };

  public papersPaperUrl: string = BasicRoutes.clientPapersPaper;
  public setid: string;
  public paperid: string;
  public paperParts: Array<PaperPart> = [];
  public paperReports: any = {};
  public getMarks: Array<Object>=[];

  public paperSettitle: Object;
  public part1ClientStatus: any;
  public part2ClientStatus: any;

  public part1Marks: any = ' ';
  public part2Marks: any = ' ';
  public totalMarks: any = ' ';
  public attemp: Array<NewAttempt> = [];
  public previewChart : boolean = false;
  public previewStaticType:string = '';

  constructor(private route: ActivatedRoute,
    private httpClientService: HttpClientService,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService,
    private router: Router,
    private backButtonService: BackButtonService) { }

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.paperid = params['paperid'];
    });
    this.cookieManagerService.setCookie(CookieNames.paperId, this.paperid, false, 1);
    this.setid = this.cookieManagerService.getCookie(CookieNames.paperSetKey, false).toString();
    this.paperSettitle = this.cookieManagerService.getCookie(CookieNames.paperTitle, false);
    this.getPaperPartsStatics();
    this.getPaperPartsInPaper();
    this.setTotalVersionsCharts();
    // get previous Static Type
    this.previewStaticType = this.backButtonService.getStaticType();
    //this.setChartData();
    window.scrollTo(0, 0);
  }

  public partNew: boolean = false;

  getMarksObj(part) {
    let returnObj = { imageUrl: '/assets/img/status-new.svg', class: 'available', logoClass: 'status-new' };
    if (part.clientStatus == OnlineStatus.INPROGRESS) {
      returnObj.imageUrl = '/assets/img/status-completed.svg';
      returnObj.class = 'ongoing';
      returnObj.logoClass = 'status-ongoing';
    } else if (part.clientStatus == OnlineStatus.COMPLETE) {
      returnObj.imageUrl = '/assets/img/status-completed.svg';
      returnObj.class = 'completed';
      returnObj.logoClass = 'status-completed';
    }else{
      if(!this.partNew){
        this.partNew = true;
      }
    }
    this.getMarks.push(returnObj);
  }

  getPaperPartsInPaper() {
    // comment
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaper, {
      [ApiEndpoints.paperid]: this.paperid
    }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      this.paperParts = response.paperPart;
      response.paperPart.forEach(item =>{
          this.getMarksObj(item);
      });
    }, error => {
      this.ErrorManagerService.setError(error);
    });
  }

  getPaperPartsStatics() {
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaperStatics, {
      [ApiEndpoints.paperid]: this.paperid
    }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      this.paperReports = response;

      this.totalMarks = response.totalMarks;

      if (response.partOne !== null) {
        this.part1Marks = Math.round(response.partOne);
      }
      if (response.partTwo !== null) {
        this.part2Marks = Math.round(response.partTwo);
      }
      // this.circleComp.animate(Math.round(response.totalMarks) / 200);
    }, error => {
      // this.ErrorManagerService.setError(error);
    });
  }

  paperSetRouter(partId) {
    this.cookieManagerService.setCookie(CookieNames.paperPartId, partId, false, 1);
    this.router.navigate(['/home/reports/papers/' + partId + '/summary']);
  }

  //chart data
  public lineChartData: Array<any> = [
    { data: [], label: 'පළමු කොටස' },
    { data: [], label: 'දෙවන කොටස' }
  ];
  public lineChartLabels: Array<any> = [];
  public lineChartOptions: any = {
    responsive: true,
    scales: {
      yAxes: [{
        scaleLabel: {
          display: true,
          labelString: 'ලකුණු'
        },
        ticks: {
          beginAtZero: true,
          max: 100
        }
      }],
      xAxes: [{
        scaleLabel: {
          display: true,
          labelString: 'උත්සහ කල වාර'
        }
      }]
    }
  };
  public lineChartColors: Array<any> = [
    { // grey
      backgroundColor: 'rgba(139, 195, 74,1.0)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // dark grey
      backgroundColor: 'rgba(205, 220, 57,1.0)',
      borderColor: 'rgba(77,83,96,1)',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    }
  ];
  public lineChartLegend: boolean = true;
  public lineChartType: string = 'bar';

  // setChartData() {
  //   this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaperChartData, {
  //     [ApiEndpoints.paperid]: this.paperid
  //   }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
  //     this.attemp = new Attemp(response);
  //     this.attemp.partOne.versions.forEach(item => {
  //         this.lineChartLabels.push(item);
  //     });
  //     this.lineChartData = [
  //       { data: this.attemp.partOne.total, label: 'පළමු කොටස'},
  //       { data: this.attemp.partTwo.total, label: 'දෙවන කොටස'}
  //     ];
  //     this.previewChart = true;
  //   }, error => {
  //     this.previewChart = false;
  //     console.log(error);
  //   });
  // }

  setTotalVersionsCharts(){
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaperChartData, {
      [ApiEndpoints.paperid]: this.paperid
    }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      if(response){
        response.forEach(arr => {
          this.attemp.push(new NewAttempt(arr));
        });
      }
      this.previewChart = true;
    }, error => {
      this.previewChart = false;
    });
  }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/report/components/report-parts.component.ts